import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';

/**
 * AI:
 * Status: 'in progress'
 * Type: Service
 * SubType: MvsCrudService
 * Reason: Entity service of `bm.CustomerBillingAccountBillingRunMessage` - the message a billing-run
 *   step (today: the SEPA pre-check, `BmSepaPreCheckMessageWriter`) writes about ONE customer billing
 *   account within ONE run. Generic controller `/mvsa/bm/customerBillingAccountBillingRunMessages`,
 *   no custom endpoints.
 *
 *   Why a service file exists although the entity is plain CRUD (fe_core_mvs-crud-service decision
 *   table, row "getObjectIcon() / getObjectLabels()"): the entity is opened through generic dialogs
 *   and links from the run dashboard and the account detail (round 11, WP-A/A3, FD-R11-5 "full
 *   registration"), and the generic object header derives its icon and its title from exactly these
 *   two overrides. Without them a message dialog opens with the framework's default icon and an
 *   empty title. There is deliberately NO `getObjectComponent()` override: `read` stays the generic
 *   `mvs-crud-object` rendering (the message is read-only data written by the run; the frontend
 *   never edits, restores or deletes it - requirement 11 §7 rule 4).
 *
 *   Reads of the message LIST never go through this service's `list()` - they are QL
 *   (the WidgetFactory table of the account detail, the count queries of
 *   `bm-current-bank-account-ql.ts`, the count pipes of `bm-billing-run-tab-count-ql.service.ts`,
 *   and the WidgetFactory widgets of the run dashboard).
 */
@Injectable({providedIn: 'root'})
export class CustomerBillingAccountBillingRunMessageService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/customerBillingAccountBillingRunMessages');
    }

    /**
     * Same glyph the backend enum `BmCustomerBillingAccountMessageType.SEPA_PRE_CHECK` declares as its
     * `uiImage`, so the object header and the enum badge in a table agree.
     */
    override getObjectIcon(): string {
        return 'fa-solid fa-magnifying-glass-dollar';
    }

    /** The German message text IS the title of the object - there is no separate name column. */
    override getObjectLabels(): string[] {
        return ['message'];
    }
}
